import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-locuri-consum-operator',
  templateUrl: './places-operator.component.html',
  styleUrls: ['./places-operator.component.scss']
})
export class PlacesOperatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
